/* LP 1024b · ネムポケ — shell behaviour.
   M-01 gallery counter+thumbs · M-08 tabs · M-11 sticky ATC · M-14 section pixel. */
(function () {
  "use strict";
  var root = document.getElementById("lp1024c");
  if (!root) return;
  var CFG = window.LP1024C || {};
  var vid = CFG.variantId;

  /* ---- M-01 gallery: counter + thumb sync ---------------------------- */
  var slides = root.querySelector(".lp-slides");
  var count  = root.querySelector(".lp-count b");
  var thumbs = [].slice.call(root.querySelectorAll(".lp-thumbs button"));
  function currentIndex() {
    if (!slides || !slides.firstElementChild) return 0;
    return Math.round(slides.scrollLeft / slides.firstElementChild.offsetWidth);
  }
  if (slides) {
    var raf;
    slides.addEventListener("scroll", function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = currentIndex();
        if (count) count.textContent = i + 1;
        thumbs.forEach(function (b, n) { b.setAttribute("aria-current", n === i ? "true" : "false"); });
      });
    }, { passive: true });
  }
  thumbs.forEach(function (b) {
    b.addEventListener("click", function () {
      var i = +b.dataset.i;
      if (slides && slides.firstElementChild) {
        slides.scrollTo({ left: i * slides.firstElementChild.offsetWidth, behavior: "smooth" });
      }
    });
  });

  /* ---- M-08 tabs ------------------------------------------------------ */
  var tabs = [].slice.call(root.querySelectorAll(".lp-tabs button"));
  tabs.forEach(function (t) {
    t.addEventListener("click", function () {
      tabs.forEach(function (o) { o.setAttribute("aria-selected", o === t ? "true" : "false"); });
      ["info", "spec", "rev"].forEach(function (p) {
        var el = document.getElementById("pane-" + p);
        if (el) el.hidden = (p !== t.dataset.pane);
      });
      var nav = root.querySelector(".lp-tabs");
      if (nav) window.scrollTo({ top: nav.offsetTop - 4, behavior: "smooth" });
      push({ event: "lp_tab", tab: t.dataset.pane });
    });
  });

  /* ---- variant swatches ---------------------------------------------- */
  var price  = document.getElementById("lp-price");
  var sprice = document.getElementById("lp-sprice");
  var was    = document.getElementById("lp-was");
  var buy    = document.getElementById("lp-buy");
  [].slice.call(root.querySelectorAll("#lp-swatches button")).forEach(function (b) {
    b.addEventListener("click", function () {
      [].slice.call(root.querySelectorAll("#lp-swatches button")).forEach(function (o) {
        o.setAttribute("aria-pressed", o === b ? "true" : "false");
      });
      vid = +b.dataset.vid;
      root.dataset.vid = vid;
      if (price)  price.textContent  = b.dataset.price;
      if (sprice) sprice.textContent = b.dataset.price;
      if (was && b.dataset.compare)   was.textContent = b.dataset.compare;
      var avail = b.dataset.available === "true";
      if (buy) { buy.disabled = !avail; buy.textContent = avail ? CFG.cta : CFG.soldout; }
      try { history.replaceState({}, "", "?variant=" + vid); } catch (e) {}
      push({ event: "lp_variant", variant_id: vid, variant: b.textContent.trim() });
    });
  });

  /* ---- M-11 add to cart → theme cart drawer --------------------------- */
  var err = document.getElementById("lp-err");
  var busy = false;
  function add(btn) {
    if (busy) return;
    busy = true;
    if (err) err.hidden = true;
    var label = btn.textContent;
    btn.textContent = CFG.adding;
    btn.setAttribute("aria-busy", "true");
    var drawer = document.querySelector("cart-drawer");
    var body = { items: [{ id: vid, quantity: 1 }] };
    if (drawer && window.routes) {
      var sections = drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : null;
      if (sections) { body.sections = sections; body.sections_url = window.location.pathname; }
    }
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : "/cart/add") + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || "error"); return j; }); })
      .then(function (res) {
        push({ event: "add_to_cart", variant_id: vid });
        if (drawer && typeof drawer.renderContents === "function") {
          drawer.classList.remove("is-empty");
          drawer.renderContents(res);
          if (typeof drawer.open === "function") drawer.open(btn);
        } else {
          window.location.href = "/cart";
        }
      })
      .catch(function () {
        if (err) { err.textContent = "通信に失敗しました。もう一度お試しください。"; err.hidden = false; }
      })
      .finally(function () {
        busy = false;
        btn.removeAttribute("aria-busy");
        btn.textContent = label;
      });
  }
  if (buy) buy.addEventListener("click", function () { add(buy); });
  var sbuy = document.getElementById("lp-sbuy");
  if (sbuy) sbuy.addEventListener("click", function () {
    var box = root.querySelector(".lp-buybox");
    var onInfoTab = !document.getElementById("pane-info").hidden;
    if (window.scrollY > 900 || !onInfoTab) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setTimeout(function () { add(sbuy); }, 420);
    } else { add(sbuy); }
  });

  /* ---- M-14 section-view pixel ---------------------------------------- */
  function push(o) { window.dataLayer = window.dataLayer || []; window.dataLayer.push(o); }
  var seen = {};
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var n = e.target.dataset.track;
        if (!e.isIntersecting || seen[n]) return;
        seen[n] = 1;
        push({ event: "section_view", section_name: n });
      });
    }, { threshold: 0.6 });
    [].slice.call(root.querySelectorAll("[data-track]")).forEach(function (s) { io.observe(s); });
  }
})();
